module.exports = __webpack_public_path__ + "img/php.d8697dde.svg";